import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox as BaseCheckbox } from "./styled";
const AgreementRequired = (props) => (_jsx(BaseCheckbox, Object.assign({}, props, { children: ({ isSelected }) => (_jsx("div", { className: "checkbox", children: _jsx("svg", { "aria-hidden": "true", viewBox: "0 0 18 18", children: isSelected ? _jsx("polyline", { points: "1 9 7 14 15 4" }) : null }) })) })));
export default AgreementRequired;
